import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="therapeutic_area_name_field"
export default class extends Controller {
  static targets = ["otherTherapeuticSelect", "otherTherapeuticDiv", "otherTherapeuticInput"];

  connect(){
    if (this.otherTherapeuticSelectTarget.value == "Other"){
      this.otherTherapeuticInputTarget.setAttribute("required", true)
    } else {
      this.otherTherapeuticInputTarget.removeAttribute("required")
    }
  }
  
  handleTherapeuticArea() {
    if (this.otherTherapeuticSelectTarget.value == "Other"){
      this.otherTherapeuticDivTarget.classList.remove("d-none")
      this.otherTherapeuticInputTarget.setAttribute("required", true)
    } else {
      this.otherTherapeuticDivTarget.classList.add("d-none")
      this.otherTherapeuticInputTarget.removeAttribute("required")
      this.otherTherapeuticInputTarget.value = ""
    }
  }

}
